import { api } from "./api/apiSlice";

interface Country {
  id: string; // Changed from number to string to match backend
  name: string;
  country_code: string; // Changed from code to country_code to match backend
  nationality: string;
  phone_code: string;
}

export const countryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAlCountry: builder.query<Country[], void>({
      query: () => "countries/",
    }),
    getFilterCountry: builder.query<Country[], void>({
      query: () => "countries/members/",
      providesTags: ["Country"],
    }),
  }),
});

export const { useGetAlCountryQuery, useGetFilterCountryQuery } = countryApi;
